import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss']
})
export class EmptyPageComponent implements OnInit {
  @Input() title:any;
  @Input() message:any;
  @Input() action:any;
  
  constructor() { }

  ngOnInit(): void {
  }
}
